import { useEffect, useState } from 'react';
import { Button } from './ui/Button';

/** Copies `text` to the clipboard and announces the result politely. */
export function CopyButton({ text, label = 'Copy link', size = 'sm' }: { text: string; label?: string; size?: 'sm' | 'md' }) {
  const [state, setState] = useState<'idle' | 'copied' | 'failed'>('idle');

  useEffect(() => {
    if (state === 'idle') return;
    const t = window.setTimeout(() => setState('idle'), 2000);
    return () => window.clearTimeout(t);
  }, [state]);

  const copy = async () => {
    try {
      await navigator.clipboard.writeText(text);
      setState('copied');
    } catch {
      setState('failed');
    }
  };

  return (
    <span className="inline-flex items-center gap-2">
      <Button variant="secondary" size={size} icon={state === 'copied' ? 'check' : 'copy'} onClick={copy} title={text}>
        {state === 'copied' ? 'Copied' : label}
      </Button>
      <span role="status" aria-live="polite" className="sr-only">
        {state === 'copied' ? 'Link copied to clipboard' : state === 'failed' ? 'Copy failed' : ''}
      </span>
    </span>
  );
}
